// extracted by mini-css-extract-plugin
export default {"formWrapper":"Ss0RK2Dg","form":"_uDXi1Df","title":"kFIsqnV3","genderWrapper":"eae42MXv","genderButton":"K1w1ulcG","field":"bR_ZF_oV","active":"OESzkBLf","notion":"rE9W2HFR","error":"_vrrzcqS"};
    if(module.hot) {
      // 1738090063601
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  